var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyTwoPeopleOutlined = function SvgHappyTwoPeopleOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2BAC36",
    strokeWidth: 1.5,
    d: "M.764 17.25A4.25 4.25 0 0 1 5 13.35h1a4.25 4.25 0 0 1 4.236 3.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2BAC36",
    strokeWidth: 1.5,
    d: "M9.916 14.9a4.25 4.25 0 0 1 4.25-4.25h2.833a4.25 4.25 0 0 1 4.25 4.25v2.35H9.916zM19.417 4.5c0 2.058-1.704 3.75-3.834 3.75S11.75 6.558 11.75 4.5 13.453.75 15.583.75s3.834 1.692 3.834 3.75ZM8.417 8.1c0 1.561-1.292 2.85-2.916 2.85S2.584 9.661 2.584 8.1s1.293-2.85 2.917-2.85S8.417 6.539 8.417 8.1Z"
  })));
};
export default SvgHappyTwoPeopleOutlined;